module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save":"Save parameters","parameterName":"Parameter name","parameterDescription":"Parameter Description","parameterValue":"Value","parametersChanged":"Parameters changed: "},"no":{"save":"Lagre parameterer","parameterName":"Parameter navn","parameterDescription":"Parameter beskrivelse","parameterValue":"Verdi","parametersChanged":"Antall parameterer som ble oppdatert: "}}')
  delete Component.options._Ctor
}
